import { getDocumentOrThrow } from "@faire/web--source/common/globals/getDocument";
/**
 * @returns true if the referrer is facebook or instagram
 */ export var isComingFromFacebookOrInstagram = function() {
    return [
        "facebook",
        "instagram"
    ].some(function(ref) {
        return getDocumentOrThrow().referrer.includes(ref);
    });
};
